import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	title1: {
		'id': 'FAQ.title1',
		'defaultMessage': "General",
	},
	title2: {
		'id': 'FAQ.title2',
		'defaultMessage': "Technical",
	},

	'title1.header': {
		'id': 'FAQ.title1.header',
		'defaultMessage': "Lorem ipsum dolor sit amet, consectetur adipisicing elit.",
	},
	'title1.content': {
		'id': 'FAQ.title1.content',
		'defaultMessage': "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aut dolorum laudantium nemo numquam odio perspiciatis quia veniam? Itaque, nam?",
	},
});





// WEBPACK FOOTER //
// ./src/components/FAQ/messages.js